var React = require('react');

function Blob (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M18.009 24.25c.996 3.618 2.868 6.942 3.987 10.519 1.12 3.577 1.414 7.72-.615 10.879-4.124 6.42-14.904 5.182-19.338 11.389-2.124 2.974-2.19 6.915-1.94 10.56.428 6.226 1.581 12.491 4.36 18.078 2.78 5.587 7.317 10.456 13.128 12.742 5.582 2.194 11.864 1.857 17.716.536 11.786-2.647 22.799-9.387 29.79-19.26 6.99-9.873 9.666-22.904 6.249-34.503-2.079-7.064-6.218-13.321-10.495-19.316C53.41 15.444 44.558 4.811 32.036.544c-11.703-3.988-16.42 15.031-14.027 23.705z"}));
}

Blob.defaultProps = {"viewBox":"0 0 73 100"};

module.exports = Blob;

Blob.default = Blob;
